import { render } from "./AllNewsView.vue?vue&type=template&id=1d2a6caf&scoped=true"
import script from "./AllNewsView.vue?vue&type=script&lang=js"
export * from "./AllNewsView.vue?vue&type=script&lang=js"

import "./AllNewsView.vue?vue&type=style&index=0&id=1d2a6caf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2a6caf"]])

export default __exports__